module.exports = __webpack_public_path__ + "static/media/gambler.955bb641.png";